import { Text } from 'blaze-ui/Text/Text'
import { useCreditUsage } from 'hooks/useCreditUsage'
import React from 'react'

// Displays a warning message if the user is low on credits or out of credits
export const CreditsLowWarning = () => {
  const { isLowOnCredits, isOutOfCredits } = useCreditUsage()

  if (!isLowOnCredits && !isOutOfCredits) return null

  return (
    <Text variant="secondary" color="var(--upgrade)">
      {isOutOfCredits ? 'Get more credits' : 'Running low on credits'}
    </Text>
  )
}
